import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';

@Component({
    templateUrl:"./page-not-found.component.html"
})
export class PageNotFoundComponent implements OnInit, AfterViewInit { 
    public pageTitle: string = 'Page Not Found';
    constructor(private authService: AuthService, private appCommonService: AppCommonService) {
        this.appCommonService.pageContentAdditionalClass = "";        
        this.appCommonService.pageName = this.pageTitle;
    }
    ngOnInit()
    {
        
    }

    ngAfterViewInit(){
        
    }
}



// WEBPACK FOOTER //
// ./src/app/pagenotfound/page-not-found.component.ts